module.exports = __webpack_public_path__ + "static/media/art9.a729adff.jpg";